module.exports = __webpack_public_path__ + "img/3745149.jpg";